(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@reduxjs/toolkit"));
	else if(typeof define === 'function' && define.amd)
		define(["@Reduxjs/Toolkit"], factory);
	else if(typeof exports === 'object')
		exports["lib-am-common"] = factory(require("@reduxjs/toolkit"));
	else
		root["lib-am-common"] = factory(root["@Reduxjs/Toolkit"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./actions/Rehab.action.ts":
/*!*********************************!*\
  !*** ./actions/Rehab.action.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toggleRehabTreePublishStateRejected = exports.toggleRehabTreePublishStateResolved = exports.toggleRehabTreePublishState = exports.getRehabResultRejected = exports.getRehabResultResolved = exports.getRehabResult = exports.getRehabTreesResolved = exports.getRehabTreesRejected = exports.getRehabTrees = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getRehabTrees = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabTrees'));
exports.getRehabTreesRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabTreesRejected'));
exports.getRehabTreesResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabTrees/resolved'));
exports.getRehabResult = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabResult'));
exports.getRehabResultResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabResult/resolved'));
exports.getRehabResultRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabResult/rejected'));
exports.toggleRehabTreePublishState = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('toggleRehabTreePublishState'));
exports.toggleRehabTreePublishStateResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('toggleRehabTreePublishState/resolved'));
exports.toggleRehabTreePublishStateRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('toggleRehabTreePublishState/rejected'));


/***/ }),

/***/ "./actions/assetDetail.actions.ts":
/*!****************************************!*\
  !*** ./actions/assetDetail.actions.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAssetLocation = exports.setAssetLocationIsWaiting = exports.setAssetLocation = exports.setInspectionsValidatingAsset = exports.clearValidAssetIds = exports.checkAssetIdsRejected = exports.checkAssetIdsResolved = exports.checkAssetIds = exports.addAssetDetailNote = exports.setAssetDetailNotesIsWaiting = exports.setAssetDetailIsWaiting = exports.getAssetDetailMapInsertResolved = exports.getAssetDetailRejected = exports.getAssetDetailResolved = exports.getAssetDetail = exports.loadAssetDetails = exports.getAssetCountsRejected = exports.getAssetCountsResolved = exports.getAssetCounts = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetCounts = (0, toolkit_1.createAction)('assets/getAssetCounts');
exports.getAssetCountsResolved = (0, toolkit_1.createAction)('assets/getAssetCounts/resolved');
exports.getAssetCountsRejected = (0, toolkit_1.createAction)('assets/getAssetCounts/rejected');
exports.loadAssetDetails = (0, toolkit_1.createAction)('assets/loadAssetDetails');
exports.getAssetDetail = (0, toolkit_1.createAction)('assets/getAssetDetail');
exports.getAssetDetailResolved = (0, toolkit_1.createAction)('assets/getAssetDetail/resolved');
exports.getAssetDetailRejected = (0, toolkit_1.createAction)('assets/getAssetDetail/rejected');
exports.getAssetDetailMapInsertResolved = (0, toolkit_1.createAction)('assets/getAssetDetailMapInsert/resolved');
exports.setAssetDetailIsWaiting = (0, toolkit_1.createAction)('assets/getAssetDetail/isWaiting');
exports.setAssetDetailNotesIsWaiting = (0, toolkit_1.createAction)('assets/getAssetDetail/notesIsWaiting');
exports.addAssetDetailNote = (0, toolkit_1.createAction)('assets/addAssetDetailNote');
exports.checkAssetIds = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/checkAssetIds'));
exports.checkAssetIdsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/checkAssetIdsResolved'));
exports.checkAssetIdsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/checkAssetIdsRejected'));
exports.clearValidAssetIds = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/clear'));
exports.setInspectionsValidatingAsset = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/validatingAsset'));
exports.setAssetLocation = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/setAssetLocation'));
exports.setAssetLocationIsWaiting = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/setAssetLocationIsWaiting'));
exports.getAssetLocation = (0, toolkit_1.createAction)('assetDetail/getAssetLocation');


/***/ }),

/***/ "./actions/assetManhole.actions.ts":
/*!*****************************************!*\
  !*** ./actions/assetManhole.actions.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAssetManholeRejected = exports.getAssetManholeResolved = exports.getAssetManhole = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetManhole = (0, toolkit_1.createAction)('assets/getAssetManhole');
exports.getAssetManholeResolved = (0, toolkit_1.createAction)('assets/getAssetManhole/resolved');
exports.getAssetManholeRejected = (0, toolkit_1.createAction)('assets/getAssetManhole/rejected');


/***/ }),

/***/ "./actions/assetPipe.actions.ts":
/*!**************************************!*\
  !*** ./actions/assetPipe.actions.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAssetPipeRejected = exports.getAssetPipeResolved = exports.getAssetPipe = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetPipe = (0, toolkit_1.createAction)('assets/getAssetPipe');
exports.getAssetPipeResolved = (0, toolkit_1.createAction)('assets/getAssetPipe/resolved');
exports.getAssetPipeRejected = (0, toolkit_1.createAction)('assets/getAssetPipe/rejected');


/***/ }),

/***/ "./actions/assetRisk.actions.ts":
/*!**************************************!*\
  !*** ./actions/assetRisk.actions.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRiskSummaryRejected = exports.getRiskSummaryResolved = exports.getRiskSummary = exports.setRiskSummaryIsLoading = exports.getRiskSettingRejected = exports.getRiskSettingResolved = exports.getRiskSetting = exports.getAssetRiskHistoryRejected = exports.getAssetRiskHistoryResolved = exports.getAssetRiskHistory = exports.getAssetRiskRejected = exports.getAssetRiskWaiting = exports.getAssetRiskResolved = exports.getAssetRisk = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetRisk = (0, toolkit_1.createAction)('assets/getAssetRisk');
exports.getAssetRiskResolved = (0, toolkit_1.createAction)('assets/getAssetRisk/resolved');
exports.getAssetRiskWaiting = (0, toolkit_1.createAction)('assets/getAssetRisk/waiting');
exports.getAssetRiskRejected = (0, toolkit_1.createAction)('assets/getAssetRisk/rejected');
exports.getAssetRiskHistory = (0, toolkit_1.createAction)('assets/getAssetRiskHistory');
exports.getAssetRiskHistoryResolved = (0, toolkit_1.createAction)('assets/getAssetRiskHistory/resolved');
exports.getAssetRiskHistoryRejected = (0, toolkit_1.createAction)('assets/getAssetRiskHistory/rejected');
exports.getRiskSetting = (0, toolkit_1.createAction)('assets/getRiskSetting');
exports.getRiskSettingResolved = (0, toolkit_1.createAction)('assets/getRiskSetting/resolved');
exports.getRiskSettingRejected = (0, toolkit_1.createAction)('assets/getRiskSetting/rejected');
exports.setRiskSummaryIsLoading = (0, toolkit_1.createAction)('assets/setRiskSummaryIsLoading');
exports.getRiskSummary = (0, toolkit_1.createAction)('assets/getRiskSummary');
exports.getRiskSummaryResolved = (0, toolkit_1.createAction)('assets/getRiskSummary/resolved');
exports.getRiskSummaryRejected = (0, toolkit_1.createAction)('assets/getRiskSummary/rejected');


/***/ }),

/***/ "./actions/charts.actions.ts":
/*!***********************************!*\
  !*** ./actions/charts.actions.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clearCharts = exports.clearChart = exports.getChartsRejected = exports.getChartsResolved = exports.getCharts = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getCharts = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('charts'));
exports.getChartsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('charts/resolved'));
exports.getChartsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('charts/rejected'));
exports.clearChart = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('chart/clear'));
exports.clearCharts = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('charts/clear'));


/***/ }),

/***/ "./actions/configuration.actions.ts":
/*!******************************************!*\
  !*** ./actions/configuration.actions.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getConfigurationRejected = exports.getConfigurationResolved = exports.getConfigurationWithUploadId = exports.getConfigurationWithMapping = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getConfigurationWithMapping = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('configuration/getConfigurationWithMapping'));
exports.getConfigurationWithUploadId = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('configuration/getConfigurationWithUploadId'));
exports.getConfigurationResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('configuration/getConfiguration/resolved'));
exports.getConfigurationRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('configuration/getConfiguration/rejected'));


/***/ }),

/***/ "./actions/fullInspection.actions.ts":
/*!*******************************************!*\
  !*** ./actions/fullInspection.actions.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setNotesIsWaiting = exports.setFullInspectionIsWaiting = exports.addNoteRejected = exports.addNote = exports.getNotesRejected = exports.getNotesResolved = exports.getNotes = exports.clearFullInsp = exports.getFullInspRejected = exports.getFullInspResolved = exports.getFullInsp = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getFullInsp = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInsp'));
exports.getFullInspResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspResolved'));
exports.getFullInspRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspRejected'));
exports.clearFullInsp = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/clearFullInsp'));
exports.getNotes = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspNotes'));
exports.getNotesResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspNotesResolved'));
exports.getNotesRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspNotesRejected'));
exports.addNote = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/addNote'));
exports.addNoteRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/addNoteRejected'));
exports.setFullInspectionIsWaiting = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/isWaiting'));
exports.setNotesIsWaiting = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/notesIsWaiting'));


/***/ }),

/***/ "./actions/index.ts":
/*!**************************!*\
  !*** ./actions/index.ts ***!
  \**************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getConfigurationWithMapping = exports.clearObservations = exports.clearFilters = exports.setTypeFilters = exports.setGradeFilters = exports.setStepOnly = exports.setContinuousOnly = exports.setJointOnly = exports.deleteObservations = exports.createObservations = exports.editObservations = exports.getObservations = exports.getAssetCounts = exports.clearValidAssetIds = exports.checkAssetIds = exports.addNote = exports.clearFullInsp = exports.getFullInsp = void 0;
__exportStar(__webpack_require__(/*! ./assetDetail.actions */ "./actions/assetDetail.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./assetManhole.actions */ "./actions/assetManhole.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./assetPipe.actions */ "./actions/assetPipe.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./assetRisk.actions */ "./actions/assetRisk.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./inspection.actions */ "./actions/inspection.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./map.actions */ "./actions/map.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./spatial.actions */ "./actions/spatial.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./observations.actions */ "./actions/observations.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./riskConfigs.actions */ "./actions/riskConfigs.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./charts.actions */ "./actions/charts.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./configuration.actions */ "./actions/configuration.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./Rehab.action */ "./actions/Rehab.action.ts"), exports);
var fullInspection_actions_1 = __webpack_require__(/*! ./fullInspection.actions */ "./actions/fullInspection.actions.ts");
Object.defineProperty(exports, "getFullInsp", ({ enumerable: true, get: function () { return fullInspection_actions_1.getFullInsp; } }));
Object.defineProperty(exports, "addNote", ({ enumerable: true, get: function () { return fullInspection_actions_1.addNote; } }));
Object.defineProperty(exports, "clearFullInsp", ({ enumerable: true, get: function () { return fullInspection_actions_1.clearFullInsp; } }));
var observations_actions_1 = __webpack_require__(/*! ./observations.actions */ "./actions/observations.actions.ts");
Object.defineProperty(exports, "getObservations", ({ enumerable: true, get: function () { return observations_actions_1.getObservations; } }));
Object.defineProperty(exports, "editObservations", ({ enumerable: true, get: function () { return observations_actions_1.editObservations; } }));
Object.defineProperty(exports, "createObservations", ({ enumerable: true, get: function () { return observations_actions_1.createObservations; } }));
Object.defineProperty(exports, "deleteObservations", ({ enumerable: true, get: function () { return observations_actions_1.deleteObservations; } }));
Object.defineProperty(exports, "setJointOnly", ({ enumerable: true, get: function () { return observations_actions_1.setJointOnly; } }));
Object.defineProperty(exports, "setContinuousOnly", ({ enumerable: true, get: function () { return observations_actions_1.setContinuousOnly; } }));
Object.defineProperty(exports, "setStepOnly", ({ enumerable: true, get: function () { return observations_actions_1.setStepOnly; } }));
Object.defineProperty(exports, "clearFilters", ({ enumerable: true, get: function () { return observations_actions_1.clearFilters; } }));
Object.defineProperty(exports, "setGradeFilters", ({ enumerable: true, get: function () { return observations_actions_1.setGradeFilters; } }));
Object.defineProperty(exports, "setTypeFilters", ({ enumerable: true, get: function () { return observations_actions_1.setTypeFilters; } }));
Object.defineProperty(exports, "clearObservations", ({ enumerable: true, get: function () { return observations_actions_1.clearObservations; } }));
var assetDetail_actions_1 = __webpack_require__(/*! ./assetDetail.actions */ "./actions/assetDetail.actions.ts");
Object.defineProperty(exports, "checkAssetIds", ({ enumerable: true, get: function () { return assetDetail_actions_1.checkAssetIds; } }));
Object.defineProperty(exports, "clearValidAssetIds", ({ enumerable: true, get: function () { return assetDetail_actions_1.clearValidAssetIds; } }));
Object.defineProperty(exports, "getAssetCounts", ({ enumerable: true, get: function () { return assetDetail_actions_1.getAssetCounts; } }));
var configuration_actions_1 = __webpack_require__(/*! ./configuration.actions */ "./actions/configuration.actions.ts");
Object.defineProperty(exports, "getConfigurationWithMapping", ({ enumerable: true, get: function () { return configuration_actions_1.getConfigurationWithMapping; } }));
exports["default"] = {
    getFullInsp: fullInspection_actions_1.getFullInsp,
    clearFullInsp: fullInspection_actions_1.clearFullInsp,
    addNote: fullInspection_actions_1.addNote,
    checkAssetIds: assetDetail_actions_1.checkAssetIds,
    clearValidAssetIds: assetDetail_actions_1.clearValidAssetIds,
    getObservations: observations_actions_1.getObservations,
    editObservations: observations_actions_1.editObservations,
    createObservations: observations_actions_1.createObservations,
    deleteObservations: observations_actions_1.deleteObservations,
    setJointOnly: observations_actions_1.setJointOnly,
    setContinuousOnly: observations_actions_1.setContinuousOnly,
    setGradeFilters: observations_actions_1.setGradeFilters,
    setTypeFilters: observations_actions_1.setTypeFilters,
    setStepOnly: observations_actions_1.setStepOnly,
    clearFilters: observations_actions_1.clearFilters,
    clearObservations: observations_actions_1.clearObservations,
    getConfigurationWithMapping: configuration_actions_1.getConfigurationWithMapping,
};


/***/ }),

/***/ "./actions/inspection.actions.ts":
/*!***************************************!*\
  !*** ./actions/inspection.actions.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setCreatingInspection = exports.setCreateInspectionId = exports.createInspection = exports.refreshInspection = exports.updateInspection = exports.getInspectionAttributesRejected = exports.getInspectionAttributesResolved = exports.getInspectionAttributesWaiting = exports.getInspectionAttributes = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getInspectionAttributes = (0, toolkit_1.createAction)('inspections/getInspectionAttributes');
exports.getInspectionAttributesWaiting = (0, toolkit_1.createAction)('inspections/getInspectionAttributes/waiting');
exports.getInspectionAttributesResolved = (0, toolkit_1.createAction)('inspections/getInspectionAttributes/resolved');
exports.getInspectionAttributesRejected = (0, toolkit_1.createAction)('inspections/getInspectionAttributes/rejected');
exports.updateInspection = (0, toolkit_1.createAction)('inspections/update');
exports.refreshInspection = 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, toolkit_1.createAction)('refreshInspection');
exports.createInspection = (0, toolkit_1.createAction)('inspections/create');
exports.setCreateInspectionId = (0, toolkit_1.createAction)('inspections/createInspectionId');
exports.setCreatingInspection = (0, toolkit_1.createAction)('inspections/creatingInspection');


/***/ }),

/***/ "./actions/map.actions.ts":
/*!********************************!*\
  !*** ./actions/map.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getMapLayers = exports.getMapRehabLayersRejected = exports.getMapRehabLayersResolved = exports.getMapRehabLayers = exports.getMapRiskLayersRejected = exports.getMapRiskLayersResolved = exports.getMapRiskLayers = exports.mapMainSelection = exports.mapMainExtent = exports.mapMainPosition = exports.mapSpatialTilesSourceHide = exports.mapSpatial = exports.mapStateUrl = exports.mapMain = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var namespace = 'libAmCommon/map/';
exports.mapMain = (0, toolkit_1.createAction)(namespace + 'map_main');
exports.mapStateUrl = (0, toolkit_1.createAction)(namespace + 'map_state_url');
exports.mapSpatial = (0, toolkit_1.createAction)(namespace + 'map_spatial');
exports.mapSpatialTilesSourceHide = (0, toolkit_1.createAction)(namespace + 'map_spatial_tiles_source_hide');
exports.mapMainPosition = (0, toolkit_1.createAction)(namespace + 'map_main_position');
exports.mapMainExtent = (0, toolkit_1.createAction)(namespace + 'map_main_extent');
exports.mapMainSelection = (0, toolkit_1.createAction)(namespace + 'map_main_selection');
exports.getMapRiskLayers = (0, toolkit_1.createAction)('amCommon/getMapRiskLayers');
exports.getMapRiskLayersResolved = (0, toolkit_1.createAction)('amCommon/MapRiskLayersResolved');
exports.getMapRiskLayersRejected = (0, toolkit_1.createAction)('amCommon/getMapRiskLayersRejected');
exports.getMapRehabLayers = (0, toolkit_1.createAction)('amCommon/getMapRehabLayers');
exports.getMapRehabLayersResolved = (0, toolkit_1.createAction)('amCommon/getMapRehabLayersResolved');
exports.getMapRehabLayersRejected = (0, toolkit_1.createAction)('amCommon/getMapRehabLayersRejected');
exports.getMapLayers = (0, toolkit_1.createAction)('amCommon/getMapLayers');


/***/ }),

/***/ "./actions/observations.actions.ts":
/*!*****************************************!*\
  !*** ./actions/observations.actions.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clearFilters = exports.setTypeFilters = exports.setGradeFilters = exports.setStepOnly = exports.setContinuousOnly = exports.setJointOnly = exports.deleteObservationsRejected = exports.deleteObservationsResolved = exports.deleteObservations = exports.editObservationsRejected = exports.editObservationsResolved = exports.editObservations = exports.createObservationsRejected = exports.createObservationsResolved = exports.createObservations = exports.clearObservations = exports.getObservationsRejected = exports.getObservationsResolved = exports.getObservations = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/getObservations'));
exports.getObservationsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/getObservationsResolved'));
exports.getObservationsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/getObservationsRejected'));
exports.clearObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/clearObservations'));
exports.createObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/createObservations'));
exports.createObservationsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/createObservationsResolved'));
exports.createObservationsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/createObservationsRejected'));
exports.editObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/editObservation'));
exports.editObservationsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/editObservationResolved'));
exports.editObservationsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/editObservationRejected'));
exports.deleteObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/deleteObservations'));
exports.deleteObservationsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/deleteObservationsResolved'));
exports.deleteObservationsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/deleteObservationsRejected'));
exports.setJointOnly = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setJointOnly'));
exports.setContinuousOnly = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setContinuousOnly'));
exports.setStepOnly = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setStepOnly'));
exports.setGradeFilters = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setGradeFilters'));
exports.setTypeFilters = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setTypeFilters'));
exports.clearFilters = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/clearFilters'));


/***/ }),

/***/ "./actions/riskConfigs.actions.ts":
/*!****************************************!*\
  !*** ./actions/riskConfigs.actions.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRiskConfigsListRejected = exports.getRiskConfigsListResolved = exports.getRiskConfigsList = exports.setRiskConfigsIsBusy = exports.currentRiskConfigsRow = exports.changeRiskConfigsPage = exports.changeRiskConfigsSlice = exports.changeRiskConfigsSort = exports.getRiskConfigsRejected = exports.getRiskConfigsResolved = exports.reloadRiskConfigs = exports.getRiskConfigsClear = exports.clearRiskConfigs = exports.getRiskConfigs = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
exports.getRiskConfigs = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigs'));
exports.clearRiskConfigs = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/clearRiskConfigs'));
var getRiskConfigsClear = function () {
    return (0, exports.clearRiskConfigs)((0, _Types_1.riskConfigsPaginationDefault)());
};
exports.getRiskConfigsClear = getRiskConfigsClear;
exports.reloadRiskConfigs = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/reloadRiskConfigs'));
exports.getRiskConfigsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigs/resolved'));
exports.getRiskConfigsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigs/rejected'));
exports.changeRiskConfigsSort = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/sort'));
exports.changeRiskConfigsSlice = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/slice'));
exports.changeRiskConfigsPage = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('amCommon/page'));
exports.currentRiskConfigsRow = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/current/row'));
exports.setRiskConfigsIsBusy = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/isBusy'));
exports.getRiskConfigsList = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigsList'));
exports.getRiskConfigsListResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigsList/resolved'));
exports.getRiskConfigsListRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigsList/rejected'));


/***/ }),

/***/ "./actions/spatial.actions.ts":
/*!************************************!*\
  !*** ./actions/spatial.actions.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSpatialLayersRejected = exports.getSpatialLayersResolved = exports.getSpatialLayers = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getSpatialLayers = (0, toolkit_1.createAction)('amCommon/getSpatialLayers');
exports.getSpatialLayersResolved = (0, toolkit_1.createAction)('amCommon/getSpatialLayersResolved');
exports.getSpatialLayersRejected = (0, toolkit_1.createAction)('amCommon/getSpatialLayersRejected');


/***/ }),

/***/ "./reducers/paginationUtils.ts":
/*!*************************************!*\
  !*** ./reducers/paginationUtils.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.updateServerFilter = exports.updateFilter = exports.rowsPerPage = exports.updateIsBusyCards = exports.updateIsBusy = exports.updateIsWaiting = exports.updateIsLoading = exports.updateRejected = exports.updateResolvedRiskConfigCard = exports.updateResolvedCard = exports.updateResolved = exports.updateGet = exports.setSelected = exports.setCurrentDbId = exports.indexToDbId = exports.removeSelected = exports.addSelected = exports.updateSort = exports.updatePage1 = exports.updateSearch = exports.updateSlice = exports.updatePage = exports.clearPagination = exports.makePaginationQuery = exports.paginationInitialState = exports.paginationDefault = exports.status200 = exports.statusLoading = exports.statusDefault = exports.rowsPerPageOptions = void 0;
var rowsPerPageOptions = function () { return [5, 10, 15, 25, 50, 100]; };
exports.rowsPerPageOptions = rowsPerPageOptions;
var statusDefault = function () { return ({ code: 800, text: 'Uncalled' }); };
exports.statusDefault = statusDefault;
var statusLoading = function () { return ({ code: 801, text: 'Loading' }); };
exports.statusLoading = statusLoading;
var status200 = function () { return ({ code: 200, text: '' }); };
exports.status200 = status200;
var queryParamPage = function (page) {
    return page && page > 1 ? "&page=".concat(page) : '';
};
var queryParamSlice = function (slice) {
    return slice && slice !== 10 && slice > 0 ? "&slice=".concat(slice) : '';
};
var queryParamSort = function (sortKey, sortDescending) {
    var q = '';
    if (sortKey === null || sortKey === void 0 ? void 0 : sortKey.length) {
        q += "&sort=".concat(encodeURIComponent(sortKey));
        if (sortDescending) {
            q += "&sortDescending=".concat(encodeURIComponent(sortDescending));
        }
    }
    return q;
};
// params that might change subtotal
var makeQueryReducers = function (pagination) {
    var q = queryParamPage(pagination.page);
    q += queryParamSlice(pagination.slice);
    q += queryParamSort(pagination === null || pagination === void 0 ? void 0 : pagination.sortKey, pagination === null || pagination === void 0 ? void 0 : pagination.sortDescending);
    return q;
};
exports.paginationDefault = {
    total: 0,
    subtotal: 0,
    slice: 10,
    pages: 1,
    page: 1,
};
exports.paginationInitialState = {
    query: '',
    status: (0, exports.statusDefault)(),
    pagination: __assign({}, exports.paginationDefault),
    rows: [],
    cards: [],
    selectedDbIds: [],
    currentDbId: '',
    isLoading: false,
    isWaiting: false,
    filter: undefined,
    serverFilter: undefined,
};
var makePaginationQuery = function (pagination) {
    var q = makeQueryReducers(pagination);
    return q.length ? '?' + q.substring(1) : '';
};
exports.makePaginationQuery = makePaginationQuery;
var clearPagination = function (state, pagination) { return (__assign(__assign({}, exports.paginationInitialState), { pagination: pagination, query: (0, exports.makePaginationQuery)(pagination) })); };
exports.clearPagination = clearPagination;
var updatePage = function (state, page) {
    var pagination = __assign(__assign({}, state.pagination), { page: page });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updatePage = updatePage;
var updateSlice = function (state, slice) {
    // If we change rows per page need to start again from page 1
    var pagination = __assign(__assign({}, state.pagination), { slice: slice, page: 1 });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updateSlice = updateSlice;
var updateSearch = function (state, search) {
    // If we change search need to start again from page 1
    var pagination = __assign(__assign({}, state.pagination), { search: search, page: 1 });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updateSearch = updateSearch;
var updatePage1 = function (state) {
    var pagination = __assign(__assign({}, state.pagination), { page: 1 });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updatePage1 = updatePage1;
var updateSort = function (state, sort) {
    // If we change sort need to start again from page 1
    var pagination = __assign(__assign({}, state.pagination), { sortKey: sort.key, sortDescending: sort.descending, page: 1 });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updateSort = updateSort;
var addSelected = function (state, add) {
    var s = new Set(state.selectedDbIds);
    add.forEach(function (a) { return s.add(a); });
    return __assign(__assign({}, state), { selectedDbIds: Array.from(s) });
};
exports.addSelected = addSelected;
var removeSelected = function (state, remove) { return (__assign(__assign({}, state), { selectedDbIds: state.selectedDbIds.filter(function (s) { return !remove.some(function (r) { return r === s; }); }) })); };
exports.removeSelected = removeSelected;
var indexToDbId = function (rows, index) {
    return index in rows && '_id' in rows[index] ? rows[index]['_id'] : '';
};
exports.indexToDbId = indexToDbId;
var setCurrentDbId = function (state, rowIndex) { return (__assign(__assign({}, state), { currentDbId: (0, exports.indexToDbId)(state.rows, rowIndex) })); };
exports.setCurrentDbId = setCurrentDbId;
var setSelected = function (state, selectedDbIds) { return (__assign(__assign({}, state), { selectedDbIds: selectedDbIds })); };
exports.setSelected = setSelected;
var updateGet = function (state, pagination) { return (__assign(__assign({}, state), { pagination: pagination, query: (0, exports.makePaginationQuery)(pagination) })); };
exports.updateGet = updateGet;
/**
 * Default update resolved for row based pagination
 * @param state current redux state
 * @param response response from the server
 * @returns the pagination object to put into redux
 */
var updateResolved = function (state, response) {
    var rows = response.data;
    // reloads should retain current and selection if still valid
    var selectedDbIds = state.selectedDbIds.filter(function (id) {
        return rows.some(function (row) { return '_id' in row && row._id === id; });
    });
    var currentDbId = rows.some(function (row) { return '_id' in row && row._id === state.currentDbId; })
        ? state.currentDbId
        : '';
    return __assign(__assign({}, exports.paginationInitialState), { status: (0, exports.status200)(), pagination: __assign({}, response.pagination), rows: response.data, scanId: response.scanId, query: (0, exports.makePaginationQuery)(response.pagination), selectedDbIds: selectedDbIds, currentDbId: currentDbId, filter: state.filter, serverFilter: state.serverFilter });
};
exports.updateResolved = updateResolved;
/**
 * Update resolved for cards
 * @param state current redux state
 * @param response response from the server
 * @returns the pagination object to put into redux
 */
var updateResolvedCard = function (state, response) {
    return __assign(__assign({}, exports.paginationInitialState), { status: (0, exports.status200)(), pagination: __assign({}, response.pagination), cards: response.data, query: (0, exports.makePaginationQuery)(response.pagination) });
};
exports.updateResolvedCard = updateResolvedCard;
/**
 * Update resolved for risk config cards
 * @param state current redux state
 * @param response response from the server
 * @returns the pagination object to put into redux
 */
var updateResolvedRiskConfigCard = function (state, response) {
    return __assign(__assign({}, exports.paginationInitialState), { status: (0, exports.status200)(), pagination: __assign({}, response.pagination), cards: response.data, query: (0, exports.makePaginationQuery)(response.pagination) });
};
exports.updateResolvedRiskConfigCard = updateResolvedRiskConfigCard;
var updateRejected = function (state, status) {
    return __assign(__assign({}, exports.paginationInitialState), { status: status });
};
exports.updateRejected = updateRejected;
var updateIsLoading = function (state, isLoading) { return (__assign(__assign({}, state), { isLoading: isLoading })); };
exports.updateIsLoading = updateIsLoading;
var updateIsWaiting = function (state, isWaiting) { return (__assign(__assign({}, state), { isWaiting: isWaiting })); };
exports.updateIsWaiting = updateIsWaiting;
var updateIsBusy = function (state, isBusy) {
    // get the loading spinner if firstLoad else get wait cursor
    var firstLoad = state.rows === undefined || state.rows.length === 0;
    return __assign(__assign({}, state), { isLoading: isBusy && firstLoad, isWaiting: isBusy && !firstLoad });
};
exports.updateIsBusy = updateIsBusy;
var updateIsBusyCards = function (state, isBusy) {
    // get the loading spinner if firstLoad else get wait cursor
    var firstLoad = state.cards === undefined || state.cards.length === 0;
    return __assign(__assign({}, state), { isLoading: isBusy && firstLoad, isWaiting: isBusy && !firstLoad });
};
exports.updateIsBusyCards = updateIsBusyCards;
var rowsPerPage = function (slice, dispatchSliceFn) {
    var opts = (0, exports.rowsPerPageOptions)();
    var options = opts.map(function (o, n) {
        return {
            name: o.toString(),
            onClick: function () {
                dispatchSliceFn(o);
            },
            cy: 'rowsPerPage-' + n,
        };
    });
    var s = slice.toString();
    var selectedIndex = options.findIndex(function (o) { return o.name === s; });
    return {
        options: options,
        selectedIndex: selectedIndex,
    };
};
exports.rowsPerPage = rowsPerPage;
var updateFilter = function (state, filter) { return (__assign(__assign({}, state), { filter: filter })); };
exports.updateFilter = updateFilter;
var updateServerFilter = function (state, filter, serverFilter) { return (__assign(__assign({}, state), { filter: filter, serverFilter: serverFilter })); };
exports.updateServerFilter = updateServerFilter;


/***/ }),

/***/ "./store/config.store.ts":
/*!*******************************!*\
  !*** ./store/config.store.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.moduleNamespace = void 0;
exports.moduleNamespace = 'libAmCommon';


/***/ }),

/***/ "./types/ObservationNotes.types.ts":
/*!*****************************************!*\
  !*** ./types/ObservationNotes.types.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoteType = void 0;
var NoteType;
(function (NoteType) {
    NoteType["SYSTEM"] = "system";
    NoteType["USER"] = "user";
})(NoteType = exports.NoteType || (exports.NoteType = {}));


/***/ }),

/***/ "./types/asset.types.ts":
/*!******************************!*\
  !*** ./types/asset.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PipeType = exports.RiskByGrade = void 0;
var RiskByGrade;
(function (RiskByGrade) {
    RiskByGrade["Negligible"] = "Negligible";
    RiskByGrade["Low"] = "Low";
    RiskByGrade["Median"] = "Median";
    RiskByGrade["High"] = "High";
    RiskByGrade["Extreme"] = "Extreme";
})(RiskByGrade = exports.RiskByGrade || (exports.RiskByGrade = {}));
var PipeType;
(function (PipeType) {
    PipeType["GravityMain"] = "Gravity Main";
    PipeType["PressurizedMain"] = "Pressurized Main";
})(PipeType = exports.PipeType || (exports.PipeType = {}));


/***/ }),

/***/ "./types/charts.types.ts":
/*!*******************************!*\
  !*** ./types/charts.types.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChartType = void 0;
var ChartType;
(function (ChartType) {
    ChartType[ChartType["InspectionOverview"] = 1] = "InspectionOverview";
    ChartType[ChartType["InspectionAssetDrilldown"] = 2] = "InspectionAssetDrilldown";
    ChartType[ChartType["InspectionMonthDrilldown"] = 3] = "InspectionMonthDrilldown";
    ChartType[ChartType["RiskOverview"] = 4] = "RiskOverview";
    ChartType[ChartType["RiskDrilldown"] = 5] = "RiskDrilldown";
})(ChartType = exports.ChartType || (exports.ChartType = {}));


/***/ }),

/***/ "./types/configuration.types.ts":
/*!**************************************!*\
  !*** ./types/configuration.types.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/filter.types.ts":
/*!*******************************!*\
  !*** ./types/filter.types.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FilterObservationGradeType = exports.FilterDateTime = exports.FilterOperator = void 0;
var FilterOperator;
(function (FilterOperator) {
    FilterOperator["Equal"] = "eq";
    FilterOperator["GreaterOrEqual"] = "gte";
    FilterOperator["LessThan"] = "lt";
})(FilterOperator = exports.FilterOperator || (exports.FilterOperator = {}));
var FilterDateTime;
(function (FilterDateTime) {
    FilterDateTime["Today"] = "today";
    FilterDateTime["LastWeek"] = "lastweek";
    FilterDateTime["LastMonth"] = "lastmonth";
    FilterDateTime["LastYear"] = "lastyear";
})(FilterDateTime = exports.FilterDateTime || (exports.FilterDateTime = {}));
var FilterObservationGradeType;
(function (FilterObservationGradeType) {
    FilterObservationGradeType["Struct"] = "struct";
    FilterObservationGradeType["OM"] = "o&m";
    FilterObservationGradeType["Service"] = "service";
})(FilterObservationGradeType = exports.FilterObservationGradeType || (exports.FilterObservationGradeType = {}));


/***/ }),

/***/ "./types/fullInspection.types.ts":
/*!***************************************!*\
  !*** ./types/fullInspection.types.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getEventOptionalFields = exports.getEventMandatoryFields = exports.getTaskOptionalFields = exports.getTaskMandatoryFields = exports.eventIgnoreFields = exports.taskIgnoreFields = void 0;
exports.taskIgnoreFields = [
    '_id',
    'taskId',
    'assetId',
    'relatedAssetId',
    'completedDate',
    'scheduledDate',
    'inspectionStatus',
    'inspectionVersion',
    'taskTypeName',
    'task',
    'tenantId',
    'uploadedById',
    'uploadedBy',
    'statusSetByUserId',
    'statusSetByUserName',
    'statusSetDate',
    'validationState',
];
exports.eventIgnoreFields = [
    '_id',
    'eventId',
    'assetId',
    'relatedAssetId',
    'openedDate',
    'reportedDate',
    'verifiedDate',
    'resolvedDate',
    'closedDate',
    'status',
    'inspectionStatus',
    'inspectionVersion',
    'eventTypeName',
    'event',
    'tenantId',
    'uploadedById',
    'uploadedBy',
    'statusSetByUserId',
    'statusSetByUserName',
    'statusSetDate',
    'validationState',
];
var getTaskMandatoryFields = function (t) {
    return {
        taskId: t('Task ID'),
        relatedAssetId: t('Asset ID'),
        scheduledDate: t('Scheduled Date'),
        completedDate: t('Completed Date'),
    };
};
exports.getTaskMandatoryFields = getTaskMandatoryFields;
var getTaskOptionalFields = function (t) {
    return {
        distance: t('Distance'),
        lat: t('Lat (WGS84)'),
        long: t('Long (WGS84)'),
        startChainage: t('Start Chainage'),
        uploadedBy: t('Uploaded By'),
    };
};
exports.getTaskOptionalFields = getTaskOptionalFields;
var getEventMandatoryFields = function (t) {
    return {
        eventId: t('Event ID'),
        relatedAssetId: t('Asset ID'),
        openedDate: t('Opened Date'),
        reportedDate: t('Reported Date'),
        verifiedDate: t('Verified Date'),
        resolvedDate: t('Resolved Date'),
        closedDate: t('Closed Date'),
    };
};
exports.getEventMandatoryFields = getEventMandatoryFields;
var getEventOptionalFields = function (t) {
    return {
        lat: t('Lat (WGS84)'),
        long: t('Long (WGS84)'),
        uploadedBy: t('Uploaded By'),
    };
};
exports.getEventOptionalFields = getEventOptionalFields;


/***/ }),

/***/ "./types/general.types.ts":
/*!********************************!*\
  !*** ./types/general.types.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/index.ts":
/*!************************!*\
  !*** ./types/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./store.types */ "./types/store.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./general.types */ "./types/general.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./filter.types */ "./types/filter.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./pagination.types */ "./types/pagination.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./ObservationNotes.types */ "./types/ObservationNotes.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./inspection.types */ "./types/inspection.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./inspectionAttributes.types */ "./types/inspectionAttributes.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./observation.types */ "./types/observation.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./fullInspection.types */ "./types/fullInspection.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./search.types */ "./types/search.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./spatial.types */ "./types/spatial.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./map.types */ "./types/map.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./asset.types */ "./types/asset.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./riskConfig.types */ "./types/riskConfig.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./charts.types */ "./types/charts.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./configuration.types */ "./types/configuration.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./rehab.types */ "./types/rehab.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./webSocket.types */ "./types/webSocket.types.ts"), exports);


/***/ }),

/***/ "./types/inspection.types.ts":
/*!***********************************!*\
  !*** ./types/inspection.types.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TaskType = exports.ValidationStatus = exports.SortDirection = exports.Direction = exports.UploadStatus = exports.InspectionStandard = void 0;
var InspectionStandard;
(function (InspectionStandard) {
    InspectionStandard["PACP"] = "PACP";
    InspectionStandard["MACP"] = "MACP";
    InspectionStandard["MSCC"] = "MSCC";
    InspectionStandard["WSA05"] = "WSA05";
})(InspectionStandard = exports.InspectionStandard || (exports.InspectionStandard = {}));
var UploadStatus;
(function (UploadStatus) {
    UploadStatus["MissingMedia"] = "missing_media";
    UploadStatus["Ready"] = "ready";
    UploadStatus["Submitted"] = "submitted";
    UploadStatus["InReview"] = "inReview";
    UploadStatus["Approved"] = "approved";
    UploadStatus["Rejected"] = "rejected";
    UploadStatus["AIProcessing"] = "ai_processing";
    UploadStatus["AIProcessed"] = "ai_processed";
    UploadStatus["AIFailed"] = "ai_failed";
    UploadStatus["VaparEdit"] = "vapar_edit";
    UploadStatus["Superseded"] = "superseded";
    UploadStatus["EventActive"] = "active";
    UploadStatus["EventVerified"] = "verified";
    UploadStatus["EventResolved"] = "resolved";
    UploadStatus["EventClosed"] = "closed";
})(UploadStatus = exports.UploadStatus || (exports.UploadStatus = {}));
var Direction;
(function (Direction) {
    Direction["Upstream"] = "upstream";
    Direction["Downstream"] = "downstream";
})(Direction = exports.Direction || (exports.Direction = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus["Error"] = "error";
    ValidationStatus["Warning"] = "warning";
    ValidationStatus["Information"] = "information";
})(ValidationStatus = exports.ValidationStatus || (exports.ValidationStatus = {}));
var TaskType;
(function (TaskType) {
    TaskType["Inspection"] = "insp";
    TaskType["Task"] = "task";
    TaskType["Event"] = "event";
})(TaskType = exports.TaskType || (exports.TaskType = {}));


/***/ }),

/***/ "./types/inspectionAttributes.types.ts":
/*!*********************************************!*\
  !*** ./types/inspectionAttributes.types.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/map.types.ts":
/*!****************************!*\
  !*** ./types/map.types.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AssetTypeUnknown = exports.AssetTypeManhole = exports.AssetTypePipe = exports.RiskLayersMask = exports.MapStatusType = void 0;
// This is a copy of map StatusType - would like to use directly via...
// import { StatusType } from '@innovyze/inno-map/map/logger/Logger';
// but the export appears broken so for now just replicate.
// So watch out for string changes in original StatusType
var MapStatusType;
(function (MapStatusType) {
    MapStatusType["DEBUG"] = "debug";
    MapStatusType["INFO"] = "info";
    MapStatusType["WARN"] = "warn";
    MapStatusType["ERROR"] = "error";
})(MapStatusType = exports.MapStatusType || (exports.MapStatusType = {}));
var RiskLayersMask;
(function (RiskLayersMask) {
    RiskLayersMask[RiskLayersMask["None"] = 0] = "None";
    RiskLayersMask[RiskLayersMask["Published"] = 1] = "Published";
    RiskLayersMask[RiskLayersMask["Unpublished"] = 2] = "Unpublished";
})(RiskLayersMask = exports.RiskLayersMask || (exports.RiskLayersMask = {}));
// TODO replace with generic solution @AssetSchemaMigration
// Used in app-am-activities
exports.AssetTypePipe = 'wwPipe';
exports.AssetTypeManhole = 'wwManhole';
exports.AssetTypeUnknown = 'assetTypeUnknown';


/***/ }),

/***/ "./types/observation.types.ts":
/*!************************************!*\
  !*** ./types/observation.types.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/pagination.types.ts":
/*!***********************************!*\
  !*** ./types/pagination.types.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/rehab.types.ts":
/*!******************************!*\
  !*** ./types/rehab.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CostUnit = void 0;
var CostUnit;
(function (CostUnit) {
    CostUnit["each"] = "each";
    CostUnit["length"] = "length";
})(CostUnit = exports.CostUnit || (exports.CostUnit = {}));


/***/ }),

/***/ "./types/riskConfig.types.ts":
/*!***********************************!*\
  !*** ./types/riskConfig.types.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskConfigsPaginationDefault = exports.ConfigPublishState = void 0;
var paginationUtils_1 = __webpack_require__(/*! @Reducers/paginationUtils */ "./reducers/paginationUtils.ts");
var ConfigPublishState;
(function (ConfigPublishState) {
    ConfigPublishState["published"] = "published";
    ConfigPublishState["unpublished"] = "unpublished";
})(ConfigPublishState = exports.ConfigPublishState || (exports.ConfigPublishState = {}));
var riskConfigsPaginationDefault = function () { return (__assign(__assign({}, paginationUtils_1.paginationDefault), { search: undefined, sortKey: 'createdAt', sortDescending: true })); };
exports.riskConfigsPaginationDefault = riskConfigsPaginationDefault;


/***/ }),

/***/ "./types/search.types.ts":
/*!*******************************!*\
  !*** ./types/search.types.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/spatial.types.ts":
/*!********************************!*\
  !*** ./types/spatial.types.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/store.types.ts":
/*!******************************!*\
  !*** ./types/store.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");


/***/ }),

/***/ "./types/webSocket.types.ts":
/*!**********************************!*\
  !*** ./types/webSocket.types.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./utils/actions.ts":
/*!**************************!*\
  !*** ./utils/actions.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addNamespace = void 0;
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var addNamespace = function (action) { return config_store_1.moduleNamespace + '/' + action; };
exports.addNamespace = addNamespace;


/***/ }),

/***/ "@reduxjs/toolkit":
/*!**********************************************************************************************************************************!*\
  !*** external {"commonjs":"@reduxjs/toolkit","commonjs2":"@reduxjs/toolkit","amd":"@Reduxjs/Toolkit","root":"@Reduxjs/Toolkit"} ***!
  \**********************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./actions/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=Actions.js.map